
import { ActionTree } from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";

export const actions: ActionTree<any, any> = {
    getHelp: ({state, getters, commit, dispatch}, identifier: string) => {

        commit('setHelpLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/help/'+identifier)

                .then(response => {
                    commit('setHelpLoading', false);
                    resolve(response);
                })
                .catch(error => {
                    commit('setHelpLoading', false);
                    reject(error);
                });
        });
    },
};
